



import React, { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from "@mui/material";
import { StyledButton, StyledCancelButton } from "../../StyledComponent";
import { post } from "../../../services/api-services";
import { useCommon } from "../../../context/CommonContext";

const AddImageDialog = ({ open, onClose, customerId, getGalary }) => {
    const { setSnackbar } = useCommon();
    const [library, setLibrary] = useState({ image: '', date: '' });
    const [error, setError] = useState(null);

    const onRest = () => {
        setLibrary({ image: '', date: '' });
        setError(null); 
    };

    const onAddImage = async () => {
        try {
            const formData = new FormData();
            formData.append('file', library.image);
            const result = await post(`/Uploads/gallery/upload`, formData);
            if (result?.statusCode === 200) {
                let data = {
                    image: result?.data?.result?.files?.file[0].name,
                    uploadedDate: library?.date,
                    uploadBy: 'admin',
                    customerId: customerId,
                    createdAt: new Date(),
                    updatedAt: new Date()
                };
                const res = await post('/Galleries', data);
                if (res?.statusCode === 200) {
                    getGalary();
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Image uploaded successfully',
                        severity: 'success'
                    });
                    onClose();
                    onRest();
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            // Check if file is an image
            if (selectedFile.type.startsWith('image/')) {
                setLibrary((prev) => ({ ...prev, image: selectedFile }));
                setError(null); // Reset error if the selected file is valid
            } else {
                setLibrary((prev) => ({ ...prev, image: '' }));
                setError('Please select a valid image file.');
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle>Add Picture</DialogTitle>
            <DialogContent>
                <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    size="small"
                    className="mb-3"
                    onChange={handleFileChange}
                />
                {error && <Typography color="error">{error}</Typography>} 
                <TextField
                    type="date"
                    label="Choose Date"
                    variant="standard"
                    required
                    value={library?.date}
                    className="w-80"
                    onChange={(e) => { setLibrary((prev) => ({ ...prev, date: e.target.value })) }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </DialogContent>
            <DialogActions>
                <StyledCancelButton onClick={() => { onClose(); onRest(); }} color="secondary">
                    Cancel
                </StyledCancelButton>
                <StyledButton onClick={onAddImage} disabled={!library?.image || !library?.date} variant="contained" color="success">
                    Save
                </StyledButton>
            </DialogActions>
        </Dialog>
    );
};

export default AddImageDialog;

